/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/075-compass2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 0110.93-4.756L6 6l-2.756 6.43A6.476 6.476 0 011.5 8zm7.643 1.143l-4.001 1.715 1.715-4.001 2.286 2.286zM8 14.5a6.476 6.476 0 01-4.43-1.744L10 10l2.756-6.43A6.5 6.5 0 018 14.5z"/>'
  }
})
